import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_QQC_QUARTERLY_LIST } from '../urls'
import ManthlyQqcQuarterlyForm from './ManthlyQqcQuarterlyForm'

export default function ManthlyQqcQuarterlyCreate({ onCancel, onSuccess }) {
    const rotationCreate = usePostRequest({ url: MANTHLY_QQC_QUARTERLY_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyQqcQuarterlyForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
